<template>
  <b-container>
    <!-- Cообщения -->
    <div id="app-msgs" class="container"></div>

    <b-row id="content" align-h="between">
      <b-col lg="7" md="10" order-lg="1">
        <!-- Компонент -->
        <router-view name="title"></router-view>
      </b-col>
      <b-col lg="4" md="10" order-lg="10" class="d-lg-flex pb-4">
        <!-- Компонент -->
        <router-view name="steps"></router-view>
      </b-col>
      <b-col lg="7" md="10" order-lg="2">
        <!-- Компонент -->
        <router-view></router-view>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "SignUp",
};
</script>

<style scoped>
@import "../common.scss";
@import "../animation.scss";

.item {
  display: flex;
  opacity: 0.65;
}
.item img {
  height: 42px;
  width: 42px;
  margin-top: 5px;
}
.item .header {
  font-size: 1em;
  font-weight: 600;
  margin-bottom: 0.3em;
}
.item .desc {
  font-size: 0.85em;
  line-height: 1.4em;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>